import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { validateSignDocumentComponent } from './validateSignDocument.component';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';


@NgModule({
    declarations: [validateSignDocumentComponent],
    imports: [TranslateModule, CommonModule, FormsModule, RouterModule, PanelModule, ScrollPanelModule, SubHeaderModule]
})




export class ValidateSignDocumentModule { }